import Link from 'components/gruenland/atoms/link';
import { GruenlandHeaderLogo } from 'components/svgr/GruenlandHeaderLogo';
import { GruenlandJuniorHeaderLogo } from 'components/svgr/GruenlandJuniorHeaderLogo';

export interface Props {
  className?: string;
  variant?: 'default' | 'junior';
  onClick?: () => void;
}

const HeaderLogo: React.FC<Props> = ({ className, variant = 'default', onClick }) => {
  return (
    <div className={className} onClick={onClick}>
      <Link link="/">
        {variant === 'default' && (
          <>
            <GruenlandHeaderLogo width={188} height={44} className="md:hidden" />
            <GruenlandHeaderLogo width={214} height={76} className="hidden md:inline" />
          </>
        )}
        {variant === 'junior' && (
          <>
            <GruenlandJuniorHeaderLogo width={188} height={44} className="md:hidden" />
            <GruenlandJuniorHeaderLogo width={214} height={76} className="hidden md:inline" />
          </>
        )}
      </Link>
    </div>
  );
};

export default HeaderLogo;
